import * as React from "react";
import { forwardRef } from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgCloseCross = ({ title, titleId, ...props }, ref) => /* @__PURE__ */ _jsxs("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	width: 32,
	height: 32,
	viewBox: "0 0 32 32",
	fill: "none",
	ref,
	"aria-labelledby": titleId,
	...props,
	children: [title ? /* @__PURE__ */ _jsx("title", {
		id: titleId,
		children: title
	}) : null, /* @__PURE__ */ _jsx("path", {
		fillRule: "evenodd",
		clipRule: "evenodd",
		d: "M14.0823 12.1925L8.55696 6.66705C8.12998 6.24006 7.38531 5.94787 6.66655 6.66667C5.94778 7.38546 6.23918 8.13095 6.66616 8.55795L12.1977 14.0895L14.0823 12.1925ZM6.568 23.5506C6.19986 23.9882 6.00498 24.6717 6.66655 25.3333C7.38531 26.0521 8.13076 25.7607 8.55773 25.3337L8.63303 25.2579C8.64734 25.2425 8.66183 25.2275 8.67649 25.2128L25.2652 8.51442C25.6675 8.08041 25.8997 7.34268 25.2233 6.66625C24.5045 5.94745 23.7599 6.23964 23.3329 6.66664L22.4482 7.55714C22.4177 7.59358 22.386 7.62822 22.3533 7.66088L6.568 23.5506ZM17.8654 19.7574L19.75 17.8603L25.3325 23.4428C25.7594 23.8698 26.0516 24.6145 25.3329 25.3333C24.6335 26.0327 23.8686 25.7607 23.4417 25.3337L17.8654 19.7574Z",
		fill: "#2D2D2D"
	})]
});
const ForwardRef = forwardRef(SvgCloseCross);
export { ForwardRef as ReactComponent };
